import { lazy } from "react";

export const LazyResultsPage = lazy(async () => ({
    default: (await import("./ResultsPage")).ResultsPage
}));
